export default __webpack_public_path__ + "static/media/ticket-discount.fb5091cb.svg";